var exports = {
  "bL": "lovedHeart__AFMvNc",
  "XN": "loveAnimation__nsIKML",
};

module.exports = exports;
